import React from 'react';
import { InputLabel } from '../../components/IndividualLite/UserDetailsForm';
import TermsAcknowledgement from '../../../../../components/TermsAcknowledgement';
import { createWrapperFieldRenderer } from '../../helpers/createWrapperFieldRenderer';
const Agreements = ({
  handleValidation,
  asLabel,
  data,
  handleChange,
  handleChangeObject,
  hasError,
  validationkeyValue
}) => {
  const renderWrapperField = createWrapperFieldRenderer({
    fieldMap: validationkeyValue,
    dataObj: data,
    disabled: asLabel,
    showError: hasError,
    defaultOnChange: handleChangeObject
  });
  return <div className='d-flex row justify-content-start mb-4'>
            <div className='flex-1'>
                <TermsAcknowledgement height={300} isDisabled={asLabel} contentType={"BUSINESS_PLUS"} isChecked={data?.acceptDelarationAggrement} onAccept={v => {
        if (!asLabel) handleChange("acceptDelarationAggrement", v);
      }} />
            </div>

            <InputLabel label="Signature of Applicant" required />
            <div className='ms-1'>
                {renderWrapperField('signature')}
            </div>
            <InputLabel required label={"Name of Applicant"} labelStyle={{
      fontSize: 15
    }} />
            <div className='row'>
                {renderWrapperField('signerFirstName', {
        className: "col-sm-4"
      })}

                {renderWrapperField('signerMiddleName', {
        className: "col-sm-4"
      })}

                {renderWrapperField('signerLastName', {
        className: "col-sm-4"
      })}

            </div>
        </div>;
};
export default Agreements;
